import React, { useState } from 'react';
import { Save, X } from 'lucide-react';

export function SegmentModal({ segment, onSave, onClose, loading }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    ai_personality: 'Vendedor amigável e consultivo',
    ai_opening_messages: ['Boa noite! Vocês trabalham com delivery?'],
    ai_pitch_message: 'Que legal! Deixa eu me apresentar...',
    audio_url: '',
    video_url: '',
    ...segment
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) return;
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-800 flex items-center justify-between">
          <h3 className="text-xl font-semibold text-white">
            {segment ? 'Editar Segmento' : 'Novo Segmento'}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Nome do Segmento *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
              placeholder="Ex: Hamburgueria"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Descrição</label>
            <input
              type="text"
              value={formData.description || ''}
              onChange={(e) => handleChange('description', e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
              placeholder="Ex: Hamburguerias e lanchonetes"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Personalidade da IA</label>
            <input
              type="text"
              value={formData.ai_personality}
              onChange={(e) => handleChange('ai_personality', e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Mensagens de Abertura (filtro)</label>
            <textarea
              value={formData.ai_opening_messages?.join('\n') || ''}
              onChange={(e) => handleChange('ai_opening_messages', e.target.value.split('\n').filter(m => m.trim()))}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white h-24"
              placeholder="Uma mensagem por linha..."
            />
            <p className="text-gray-500 text-xs mt-1">Mensagens usadas para filtrar se o lead já tem automação</p>
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Mensagem de Pitch</label>
            <textarea
              value={formData.ai_pitch_message}
              onChange={(e) => handleChange('ai_pitch_message', e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white h-24"
              placeholder="Mensagem enviada após qualificar o lead..."
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-400 mb-1">URL do Áudio</label>
              <input
                type="url"
                value={formData.audio_url || ''}
                onChange={(e) => handleChange('audio_url', e.target.value)}
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
                placeholder="https://..."
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">URL do Vídeo</label>
              <input
                type="url"
                value={formData.video_url || ''}
                onChange={(e) => handleChange('video_url', e.target.value)}
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
                placeholder="https://..."
              />
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading || !formData.name}
              className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white rounded-lg flex items-center justify-center gap-2"
            >
              <Save size={18} />
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
